import { Record } from 'immutable';
import { schema } from 'normalizr';

export const AlarmState = new Record({
  id: undefined,
  timestamp: undefined,
  site: undefined,
  alarm: undefined,
  excessive: undefined,
  is_clearable: undefined,
  discriminator: undefined,
  severity: undefined,
});

export const alarmStateSchema = new schema.Entity('alarmStates');
